// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createBtn {
    background-color: var(--primary-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: var(--white-color) !important;
    padding: 0.8rem 2rem 0.8rem 2rem !important;
    border: none !important;
    cursor: pointer !important;
}

.cancelBtn {
    background-color: var(--white-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: var(--primary-color) !important;
    padding: 0.8rem 2rem 0.8rem 2rem !important;
    border: none !important;
    cursor: pointer !important;
}

.rejectBtn {
    background-color: var(--white-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: var(--primary-color) !important;
    padding: 0.8rem 2rem 0.8rem 2rem !important;
    border: none !important;
    cursor: pointer !important;
}

.customDisabled {
    pointer-events: none;
    opacity: 0.5;
}

.btnContent {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    color: var(--white-color) !important;
}

.listHeader {
    font-size: 26px;
    color: var(--black-color) !important;
    font-weight: 900;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/userManagement/user/user.css"],"names":[],"mappings":"AAAA;IACI,iDAAiD;IACjD,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,oCAAoC;IACpC,2CAA2C;IAC3C,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,sCAAsC;IACtC,2CAA2C;IAC3C,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,sCAAsC;IACtC,2CAA2C;IAC3C,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,gBAAgB;AACpB","sourcesContent":[".createBtn {\n    background-color: var(--primary-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: var(--white-color) !important;\n    padding: 0.8rem 2rem 0.8rem 2rem !important;\n    border: none !important;\n    cursor: pointer !important;\n}\n\n.cancelBtn {\n    background-color: var(--white-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: var(--primary-color) !important;\n    padding: 0.8rem 2rem 0.8rem 2rem !important;\n    border: none !important;\n    cursor: pointer !important;\n}\n\n.rejectBtn {\n    background-color: var(--white-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: var(--primary-color) !important;\n    padding: 0.8rem 2rem 0.8rem 2rem !important;\n    border: none !important;\n    cursor: pointer !important;\n}\n\n.customDisabled {\n    pointer-events: none;\n    opacity: 0.5;\n}\n\n.btnContent {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    color: var(--white-color) !important;\n}\n\n.listHeader {\n    font-size: 26px;\n    color: var(--black-color) !important;\n    font-weight: 900;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
